import React from 'react';
// imports
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
// material icons
import CloseIcon from '@material-ui/icons/Close';
import { CloudDownload } from '@material-ui/icons';
import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
// project imports
import { useTranslation } from 'react-i18next';

function FileExportComponent(props) {
  const { exportUrl, hideExport, open, exportingFile } = props;
  const { t } = useTranslation();
  const message =
    exportUrl && !exportingFile
      ? t('fileExport.downloadReady')
      : t('fileExport.generating');

  const isLocalExportUrl = (url) => {
    if (typeof url !== 'string' || !url.trim()) return false;

    try {
      const parsedUrl = new URL(url, window.location.origin);
      return parsedUrl.pathname.startsWith('/api/local-export/');
    } catch {
      return false;
    }
  };

  const downloadFile = (url) => {
    if (isLocalExportUrl(url)) {
      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      window.open(url);
    }
    hideExport();
  };

  return (
    <Grid item container>
      <Grid item xs>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          message={<span id="message-id">{message}</span>}
          action={[
            <IconButton
              key="download"
              color="inherit"
              // eslint-disable-next-line no-extra-parens
              onClick={() => (exportUrl && !exportingFile ? downloadFile(exportUrl) : '')}>
              {exportUrl && !exportingFile ? (
                <CloudDownload />
              ) : (
                <CircularProgress style={{ color: 'white' }} size={20} />
              )}
            </IconButton>,
            <IconButton key="close" color="inherit" onClick={hideExport}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default FileExportComponent;
